import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function Appointment() {
    const [apptName, setApptName] = useState('')
    const [apptEmail, setApptEmail] = useState('')
    const [apptMobile, setApptMobile] = useState('')
    const [apptService, setApptService] = useState('E-Commerce Solution')
    const [apptMessage, setApptMessage] = useState('')
    const [apptConsent, setApptConsent] = useState(false)

    function handleAppointmentSubmit(e) {
        e.preventDefault()
        if (!apptConsent) {
            alert('Please accept the Privacy Policy and Terms & Conditions before submitting.')
            return
        }

        const to = 'info@100eyestechnologies.com'
        const subject = `Appointment Request from ${apptName || apptEmail}`
        const body = `Name: ${apptName}\nEmail: ${apptEmail}\nPhone: ${apptMobile}\nService: ${apptService}\n\nMessage:\n${apptMessage}`
        const mailto = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        window.location.href = mailto
    }

    return (
        <div className="container my-5">
            <SEO title="Online Appointment | 100Eyes Technologies" description="Schedule an appointment with 100Eyes Technologies to discuss your software, web, or cloud project." canonical="https://100eyestechnologies.com/appointment" />

            <div className="col-12" data-wow-delay="0.5s">
                <h2 className="mb-4">Online Appointment</h2>
                <form onSubmit={handleAppointmentSubmit} className="row g-3">
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input value={apptName} onChange={(e) => setApptName(e.target.value)} type="text" className="form-control" id="name" placeholder="Your Name" />
                            <label htmlFor="name">Your Name</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input value={apptEmail} onChange={(e) => setApptEmail(e.target.value)} type="email" className="form-control" id="mail" placeholder="Your Email" />
                            <label htmlFor="mail">Your Email</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input value={apptMobile} onChange={(e) => setApptMobile(e.target.value)} type="text" className="form-control" id="mobile" placeholder="Your Mobile" />
                            <label htmlFor="mobile">Your Mobile</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <select value={apptService} onChange={(e) => setApptService(e.target.value)} className="form-select" id="service">
                                <option>E-Commerce Solution</option>
                                <option>Enterprise Software & Web Solutions</option>
                                <option>Travel Technology system</option>
                                <option>Content Management System</option>
                                <option>Custom Software/Web Solution</option>
                                <option>Digital Promotion</option>
                                <option>Dev Resources</option>
                            </select>
                            <label htmlFor="service">Choose A Service</label>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-floating">
                            <textarea value={apptMessage} onChange={(e) => setApptMessage(e.target.value)} className="form-control" placeholder="Leave a message here" id="message" style={{ height: 130 }} />
                            <label htmlFor="message">Message</label>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-check">
                            <input checked={apptConsent} onChange={(e) => setApptConsent(e.target.checked)} className="form-check-input" type="checkbox" id="consent" />
                            <label className="form-check-label" htmlFor="consent">
                                I have read and agree to the <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms">Terms &amp; Conditions</Link>.
                            </label>
                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <button className="btn btn-primary w-100 py-3" type="submit">Submit Now</button>
                    </div>
                </form>
            </div>
        </div>
    )
}
